import { t } from "i18next";
import * as yup from "yup";

export const LABEL_REJECT_CHARS_REGEX = /[^a-zA-Z\d\s_-]+/;

export const VALIDATION_SCHEMA = yup.object().shape({
  singularLabel: yup
    .string()
    .trim()
    .required(
      t("neetoMolecules.taxonomy.editPane.validations.singularLabelRequired")
    ),
  pluralLabel: yup
    .string()
    .trim()
    .required(
      t("neetoMolecules.taxonomy.editPane.validations.pluralLabelRequired")
    ),
});

export const TAXONOMY_EVENTS = { UPDATED: "taxonomy_updated" };
